import { render, staticRenderFns } from "./FacbricColumnsModal.vue?vue&type=template&id=570397c8"
import script from "./FacbricColumnsModal.vue?vue&type=script&lang=js"
export * from "./FacbricColumnsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports